/// <amd-module name="WorkItemsHub/DataContracts/IWorkItemsGridData" />
import { IObjectWithKey } from "OfficeFabric/Selection";

export interface IWorkItemsGridRow extends IObjectWithKey {
    id: number;
    isCompleted: boolean;
    values: any[];
}

export type IWorkItemsGridData = IWorkItemsGridRow[];
